module.exports = __webpack_public_path__ + "static/media/Shield bottom.aa8308f7.svg";